var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "trust-star-row", attrs: { href: _vm.hrefTo } },
    [
      _c(
        "div",
        { staticClass: "star-rating" },
        _vm._l(_vm.totalStars, function(n) {
          return _c("div", { key: n, staticClass: "trust-star" }, [
            _vm.isStarFilled(n)
              ? _c("img", {
                  staticClass: "star-icon",
                  attrs: { src: _vm.starFilled, alt: "Gefüllter Stern" }
                })
              : _vm.isPartialStar(n)
              ? _c(
                  "div",
                  {
                    staticClass: "partial-star",
                    style: _vm.getPartialStarStyle(n)
                  },
                  [_c("img", { attrs: { src: _vm.starFilled } })]
                )
              : _c("img", {
                  staticClass: "star-icon",
                  attrs: { src: _vm.starEmpty, alt: "Leerer Stern" }
                })
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }